import reducer from './reducers';
export { default as communitiesOperations } from './operations';

export default reducer;
